
import { Component, Vue, Prop, Mixins, Watch } from 'vue-property-decorator';
import { messages } from '@/@next/i18n';
import { TimelineContentData, TimelineContentEventData } from '@/@types/graphql';

const config = {
  name: 'c-timeline-full-screen-slider',
  i18n: { messages },
  components: {}
};

@Component(config)
export default class CTimelineFullScreenSlider extends Vue {
  @Prop({ type: Object, required: true }) timeline!: TimelineContentData
  @Prop({ type: Number, required: false, default: 0 }) current!: number

  @Watch('current')
  onCurrentIndexChanged () {
    const container = document.getElementById('scrollable-events');
    if (!container) return
    const item = document.getElementById(`full-screen-event-${this.current}`);
    if (!item) return
    const containerWidth = container.offsetWidth;
    const itemWidth = item.offsetWidth;
    const itemOffsetLeft = item.offsetLeft;
    const scrollLeft = itemOffsetLeft - (containerWidth - itemWidth) / 2;
    container.scrollLeft = scrollLeft;
  }

  get title () {
    return this.timeline?.i18n?.title?.value || null;
  }

  get events () {
    return this.timeline?.events || [];
  }

  get event () {
    return this.events[this.current];
  }

  getDate (event: TimelineContentEventData) {
    return event?.i18n?.date.value.text.slice(0, 4) || null
  }

  next () {
    if (this.current <  this.events.length - 1) this.$emit('select', this.current + 1)
  }

  previous () {
    if (this.current >  0) this.$emit('select', this.current - 1)
  }
}
